import {
  UIAtolProtectedStatus,
  UICampaignBanner,
  UICarrierBaggagePolicies,
  UIClientFetchError,
  UIFetchStatus,
  UIFlightData,
  UISearchCabinClassExtension,
  UISearchDisplayOptions,
  UISearchResultsAggregation,
  UISearchResultsBanner,
  UISearchResultsFlightDeal,
  UISearchResultsSearchCriteria,
  UISegmentationKey,
  UISubsidizedFaresSummary
} from "@flights/types";

export type State = {
  [x: string]: any;
  campaignBanner?: UICampaignBanner;
  fetchStatus: UIFetchStatus;
  flights: UIFlightData[];
  atolProtectedStatus?: UIAtolProtectedStatus;
  availableFilters: UISearchResultsAggregation;
  subsidizedFaresSummary: UISubsidizedFaresSummary;
  cabinClassExtension?: UISearchCabinClassExtension;
  baggagePolicies?: UICarrierBaggagePolicies[];
  error?: UIClientFetchError;
  flightDeals?: UISearchResultsFlightDeal[];
  searchCriteria?: UISearchResultsSearchCriteria;
  searchId?: string;
  displayOptions?: UISearchDisplayOptions | null;
  banners?: UISearchResultsBanner[];
  personalisationSegments?: UISegmentationKey[];
};

export const getInitialState = (): State => ({
  fetchStatus: "initial",
  flights: [],
  availableFilters: {},
  subsidizedFaresSummary: [],
  error: undefined,
  campaignBanner: undefined,
  searchCriteria: undefined,
  searchId: undefined,
  displayOptions: undefined,
  banners: undefined
});
